'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _invalidDomainChars = require('./invalidDomainChars');

var _invalidDomainChars2 = _interopRequireDefault(_invalidDomainChars);

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

var validDomainChars = (0, _regexSupplant2.default)(/[^#{invalidDomainChars}]/, {
  invalidDomainChars: _invalidDomainChars2.default
});

exports.default = validDomainChars;
module.exports = exports['default'];